import { Suspense, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { publicRoutes } from "./router";
import DefaultLayout from "./layouts/DefaultLayout";
import { SpeedInsights } from "@vercel/speed-insights/react";
import MusicPlayer from "./components/MusicPlayer";
import { useTheme } from "./context/ThemeContext";
import { AnimatePresence } from "framer-motion";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function AppContent() {
  const location = useLocation();

  return (
    <DefaultLayout>
      <AnimatePresence mode="wait">
        <Suspense fallback={<div className="w-full min-h-[450px]" />}>
          <Routes location={location} key={location.pathname}>
            {publicRoutes.map((route, index) => {
              const Page = route.component;
              return (
                <Route
                  key={index}
                  path={route.path}
                  element={<Page />}
                />
              );
            })}
          </Routes>
        </Suspense>
      </AnimatePresence>
    </DefaultLayout>
  );
}

function App() {
  const { enableMusic } = useTheme();

  return (
    <Router>
      <ScrollToTop />
      {process.env.NODE_ENV === "production" && <SpeedInsights />}
      {enableMusic && <MusicPlayer />}
      <AppContent />
    </Router>
  );
}

export default App;
